import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2463f6cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-intro-security" }
const _hoisted_2 = { class: "signup-intro-security__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import Aes256 from '@P/images/signup/aes-256.svg'
import Gdpr from '@P/images/signup/gdpr.svg'
import Vasp from '@P/images/signup/vasp.svg'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupIntroSecurity',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('signupPage.securityNote')), 1),
    _createElementVNode("img", {
      src: _unref(Aes256),
      alt: "AES-256"
    }, null, 8, _hoisted_3),
    _createElementVNode("img", {
      src: _unref(Vasp),
      alt: "VASP"
    }, null, 8, _hoisted_4),
    _createElementVNode("img", {
      src: _unref(Gdpr),
      alt: "GDPR"
    }, null, 8, _hoisted_5)
  ]))
}
}

})